import Colors from '../../../../shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const TopBarContainer = styled.div<{ elOpacity: boolean }>`
  color: ${Colors['text']};
  display: flex;
  filter: ${!DeviceConfig.capabilities.disableAnimations
    ? `drop-shadow(${0 * Screen.widthRatio}px ${0 * Screen.widthRatio}px ${
        4 * Screen.widthRatio
      }px #000000);`
    : ''};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  height: ${40 * Screen.widthRatio}px;
  justify-content: space-around;
  opacity: ${(props) => (props.elOpacity ? 1 : 0)};
  padding: ${10 * Screen.widthRatio}px ${24 * Screen.widthRatio}px;
  position: absolute;
  right: ${40 * Screen.widthRatio}px;
  top: ${32 * Screen.widthRatio}px;
  width: auto;
`;

export default TopBarContainer;
